import { useEffect, useState } from 'react';

import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';

interface SaveIndicatorProps {
  lastSaved: number | null;
}

export const SaveIndicator = ({ lastSaved }: SaveIndicatorProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (lastSaved) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [lastSaved]);

  return (
    <div
      className={cn(
        "fixed top-4 right-4 z-50 flex items-center gap-2 px-3 py-2 rounded-lg bg-card border border-border shadow-lg transition-all duration-300",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"
      )}
    >
      <Check className="h-4 w-4 text-green-600 dark:text-green-400" />
      <span className="text-sm font-medium text-muted-foreground">
        Progress saved
      </span>
    </div>
  );
};
